import React, { useState, useEffect } from "react";
import "./../../css/chat-bots.scss";
import { Container, Row, Col } from "react-bootstrap";

import "react-multi-carousel/lib/styles.css";
import Techstacks from "./../../component/techstacks";

import chatbots11x from "./../../images/chatbots/chatbots-1-1x.png";
import chatbots12x from "./../../images/chatbots/chatbots-1-2x.png";
import chatbots21x from "./../../images/chatbots/chatbots-2-1x.png";
import chatbots22x from "./../../images/chatbots/chatbots-2-2x.png";
import chatbots31x from "./../../images/chatbots/chatbots-3-1x.png";
import chatbots32x from "./../../images/chatbots/chatbots-3-2x.png";
import chatbots41x from "./../../images/chatbots/chatbots-4-1x.png";
import chatbots42x from "./../../images/chatbots/chatbots-4-2x.png";
import chatbots51x from "./../../images/chatbots/chatbots-5-1x.png";
import chatbots52x from "./../../images/chatbots/chatbots-5-2x.png";

import imgNumber1 from "./../../img/imgNumber1.svg";
import imgNumber2 from "./../../img/imgNumber2.svg";
import imgNumber3 from "./../../img/imgNumber3.svg";
import imgNumber4 from "./../../img/imgNumber4.svg";
import imgNumber5 from "./../../img/imgNumber5.svg";
import imgConclusion from "./../../img/imgConclusion.svg";

function ChatBots(props) {

	const [chatbots1WD, setChatbots1WD] = useState('');
	const [chatbots2WD, setChatbots2WD] = useState('');
	const [chatbots3WD, setChatbots3WD] = useState('');
	const [chatbots4WD, setChatbots4WD] = useState('');
	const [chatbots5WD, setChatbots5WD] = useState('');
	
   useEffect(() => {
	  if( props.wd < 1200 ){
		  setChatbots1WD(chatbots11x);
		  setChatbots2WD(chatbots21x);
		  setChatbots3WD(chatbots31x);
		  setChatbots4WD(chatbots41x);
		  setChatbots5WD(chatbots51x);
	  } else if( props.wd >= 1200 ){
		  setChatbots1WD(chatbots12x);
		  setChatbots2WD(chatbots22x);
		  setChatbots3WD(chatbots32x);
		  setChatbots4WD(chatbots42x);
		  setChatbots5WD(chatbots52x);
	  }
   },[props.wd]);
  
  return (
    <div>
      <Container>
        <div className="wrapBG">
          <Row className="wrapRowChatBotsText">
            <Col xl="6" lg="6" md="12" sm="12">
              <h2 className="h2ChatBotsText">
                <span className="h2ChatBotsTextBlue">Чат-</span>боти
              </h2>
              <p className="pChatBotsText">
                Ми спеціалізуємося на розробці та впровадженні чат-рішень та чат-ботів, які дають можливість покращувати процес підтримки клієнтів у контакт-центрах страхових компаній.
              </p>
              <a href="/ua/contact" className="btn buttonOne">Зв'язатися</a>
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <img src={chatbots1WD} alt=" " className="imgChatBots" />
            </Col>
          </Row>
          <Row className="wrapRowTechStacksText">
            <Col xl="12" lg="12" md="12" sm="12">
              <h2 className="h2TechStacksText">Технічні стеки</h2>
            </Col>
          </Row>
          <Row className="wrapRowTechStacksImg">
            <Col xl="12" lg="12" md="12" sm="12">
              <div id="marquee1" className="marquee">
                <div id="blockSlider" className="marquee__inner">
                  <Techstacks />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="wrapRowDevelopmentProcessText">
            <Col xl="12" lg="12" md="12" sm="12">
              <h2 className="h2DevelopmentProcess">ЗАВДАННЯ КЛІЄНТА</h2>
            </Col>
          </Row>
          <Row className="wrapRowCustomerProblems">
            <Col xl="6" lg="6" md="12" sm="12">
              <div className="wrapTextCustomerProblems">
              <p className="pCustomerProblems">
                Наш клієнт мав на меті перенести частину запитів користувачів з телефонного каналу на чат-платформу. Основною метою було зменшити навантаження на операторів контакт-центру, впровадити автоматизацію та зменшити операційні витрати на підтримку клієнтів.
                  <br/>
                  <br/>
                Компанія клієнта мала різноманітні запити від користувачів, які можна було ефективно обробляти через чат, включаючи:
                </p>
                <ul className="ulCustomerProblems">
                  <li> Перевірку статусів страхових виплат.</li>
                  <li> Планування регулярних медичних оглядів.</li>
                  <li> Підтвердження місць розташування відділень.</li>
                  <li> Вирішення інших запитань.</li>
                </ul>
              </div>
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <img
                src={chatbots2WD}
                alt=""
                className="imgCustomerProblems"
              />
            </Col>
          </Row>
          <Row className="wrapRowCustomerProblems2">
            <Col xl="6" lg="6" md="12" sm="12">
              <img
                src={chatbots3WD}
                alt=""
                className="imgCustomerProblems2top"
              />
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <div className="wrapTextCustomerProblems">
                <p className="pCustomerProblems">
                  Багато з цих запитів як від страхової компанії, так і від її клієнтів можна було ефективно, економно та швидко вирішити через чат-платформу.
                </p>
                <p className="pCustomerProblems">
                  Для нашого клієнта важливим було налаштування під час впровадження цього рішення. Потрібна була гнучкість для налаштування конкретних бізнес-процесів для управління чат-взаємодіями. Це налаштування включало в себе:
                </p>
                <ul className="ulCustomerProblems">
                  <li> Маршрутизацію чат-сесій до відповідних груп користувачів.</li>
                  <li> Призначення агентів чату, супервайзерів та спостерігачів.</li>
                  <li> Управління історією чату та сегментування чат-сесій за темою розмови.</li>
                  <li> Моніторинг статусу чат-сесій.</li>
                </ul>
                <p className="pCustomerProblems">
                  Цей рівень налаштування забезпечив безпроблемну відповідність рішення унікальним операційним вимогам нашого клієнта.
                </p>
              </div>
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <img
                src={chatbots3WD}
                alt=""
                className="imgCustomerProblems2bottom"
              />
            </Col>
          </Row>
          <Row className="wrapRowDevelopmentProcessText">
            <Col xl="12" lg="12" md="12" sm="12">
              <h2 className="h2DevelopmentProcess">Процес розробки</h2>
            </Col>
          </Row>
          <Row className="wrapRowDevelopmentProcessBlock">
            <Col xl="12" lg="12" md="12" sm="12">
              <div className="itemImgNumber itemImgNumber1">
                <img src={imgNumber1} alt="" className="imgNumber imgNumber1" />
                <p className="pDevelopmentProcess">
                  <b>Концепція рішення та визначення проблеми:</b>
                  <br/>- Співпраця з клієнтом для визначення загальної концепції рішення та визначення основних проблем, які потрібно вирішити. Цей етап ляже в основу проекту.
                </p>
              </div>
              <div className="itemImgNumber itemImgNumber2">
                <img src={imgNumber2} alt="" className="imgNumber imgNumber2" />
                <p className="pDevelopmentProcess">
                  <b>Регулярні зустрічі для виведення статусу:</b>
                  <br/>- Проведення щотижневих зустрічей для виведення статусу зі спонсором проекту та ключовими членами робочої групи. Ці зустрічі служать платформою для постійного спілкування та вирівнювання з метою проекту.
                </p>
              </div>
              <div className="itemImgNumber itemImgNumber3">
                <img src={imgNumber3} alt="" className="imgNumber imgNumber3" />
                <p className="pDevelopmentProcess">
                  <b>План дій та узгодження концепцій:</b>
                  <br/>- Розроблення планів дій та узгодження концепцій рішення та макетів. Цей ітераційний процес допомагає створити спільне бачення та розуміння напрямку рішення.
                </p>
              </div>
              <div className="itemImgNumber itemImgNumber4">
                <img src={imgNumber4} alt="" className="imgNumber imgNumber4" />
                <p className="pDevelopmentProcess">
                  <b>Демонстрація прогресу розробки:</b>
                  <br/>- Показ проміжних результатів розробки клієнту та зацікавленим сторонам проекту. Цей процес забезпечує прозорість та дозволяє отримати ранній зворотний зв'язок та внести корективи.
                </p>
              </div>
              <div className="itemImgNumber itemImgNumber5">
                <img src={imgNumber5} alt="" className="imgNumber imgNumber5" />
                <p className="pDevelopmentProcess">
                  <b>Планування масштабованості:</b>
                  <br/>- Обговорення та коригування планів масштабованості для майбутнього рішення. Масштабованість має важливе значення для врахування зростаючого попиту та змін у страховій галузі.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="wrapRowResultsText">
            <Col xl="12" lg="12" md="12" sm="12">
              <h2 className="h2DevelopmentProcess">Результати</h2>
            </Col>
          </Row>
          <Row className="wrapRowResults1Block">
            <Col xl="6" lg="6" md="12" sm="12">
              <div className="wrapResults1">
                <p className="pResults1">
                  Процес розробки тривав 3 місяці, протягом яких наша команда успішно створила рішення, що ефективно відповідає всім вимогам, визначеним клієнтом.
                </p>
                <p className="pResults1">
                  Після завершення фази розробки ми надали матеріали для навчання співробітникам клієнта, що дозволило їм повноцінно використовувати систему. Після цього рішення було введено в експлуатацію. <br />
                  Після впровадження системи приблизно 10% запитів від клієнтів страхової компанії перейшли з телефонного каналу на чат-платформу. Це не лише досягнення цілей нашого клієнта зі зменшення навантаження на операторів контактного центру та пониження витрат на підтримку, але й покращення ефективності та зручності взаємодії з клієнтами (страхувальниками).
                </p>
              </div>
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <img src={chatbots4WD} alt="" className="imgResult1" />
            </Col>
          </Row>
          <Row className="wrapRowResults2Block">
            <Col xl="6" lg="6" md="12" sm="12" className="wrapImgResult2Top">
              <img
                src={chatbots5WD}
                alt=""
                className="imgResult2 imgResult2BTop"
              />
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <div className="wrapResults2">
                <p className="pResults1">
                  Крім того, успішне впровадження цього рішення відкрило новий шлях спілкування з клієнтами. Це означає, що в майбутньому клієнт може встановити додаткові бізнес-процеси, такі як:
                </p>
                <ul className="ulCustomerProblems">
                  <li> Продажі</li>
                  <li> Вирішення проблем</li>
                  <li> Маркетинг</li>
                </ul>
                <p className="pResults1">
                  Наступні етапи розвитку проекту передбачають більш глибоку інтеграцію рішення в ІТ-ландшафт клієнта. Це сприятиме збагаченню загального досвіду клієнтів і подальшому поліпшенню зручності для користувачів.
                  <br/>Була закладена основа для подальшого інноваційного розвитку та змін в тому, як клієнт взаємодіє та обслуговує своїх користувачів.
                </p>
              </div>
            </Col>
            <Col xl="6" lg="6" md="12" sm="12" className="wrapImgResult2Bottom">
              <img
                src={chatbots5WD}
                alt=""
                className="imgResult2 imgResult2Bottom"
              />
            </Col>
          </Row>
          <Row className="wrapRowDevelopmentProcessText">
            <Col xl="12" lg="12" md="12" sm="12">
              <h2 className="h2DevelopmentProcess">ВИСНОВОК</h2>
            </Col>
          </Row>
          <Row className="wrapRowConclusion">
            <Col xl="6" lg="6" md="12" sm="12">
              <div className="wrapConclusionText">
                <p className="pConclusion">
                  Цей результат є переконливим прикладом того, як навіть під час таких викликів як карантин, запуск нових рішень може ефективно допомагати страховим компаніям залучати нових клієнтів. Особливо варто відзначити, що це рішення має додаткову перевагу у тому, що воно дозволяє людям без попереднього досвіду в страхуванні генерувати додатковий дохід.
                  <br/>Це підкреслює цінність інновацій та адаптивності для трансформації взаємодії з клієнтами та бізнес-операцій.
                </p>
                <a href="/ua/contact" className="btn buttonOne">Зв'язатися</a>
              </div>
            </Col>
            <Col xl="6" lg="6" md="12" sm="12">
              <img src={imgConclusion} alt="" className="imgConclusion" />
            </Col>
          </Row>
        </div>
      </Container>
    </div>

  );
}

export default ChatBots;
